import { Campaign } from '../types/Campaign';
import { apiClient } from './ApiService';

const getCampaigns = async (): Promise<Campaign[]> => apiClient.get<Campaign[]>('/drone_commander/campaigns/');

const updateCampaignStatus = async (campaignId: string, newStatus: number): Promise<Campaign> =>
  apiClient.patch<Campaign>(`/drone_commander/campaigns/${campaignId}/`, { status: newStatus });

const createCampaign = async (newCampaignData: {
  name: string;
  description: string;
  status: number;
  organization: number | null;
  drones: string[];
  enable_vantis_send: boolean;
}): Promise<Campaign> => apiClient.post<Campaign>('/drone_commander/campaigns/', newCampaignData);

const AddUsersInCampaign = async (campaignId: string): Promise<{ message: string; status: string }> =>
  apiClient.patch(`/drone_commander/campaigns/add-users/`, { campaign_id: campaignId });

const RemoveUsersFromCampaign = async (campaignId: string): Promise<{ message: string; status: string }> =>
  apiClient.patch(`/drone_commander/campaigns/remove-users/`, { campaign_id: campaignId });

const getCampaignUsers = async (
  campaignId: string
): Promise<{ users: { id: string; username: string; email: string; is_controller: boolean }[] }> => {
  const response = await apiClient.get(`/drone_commander/campaigns/${campaignId}/users/`);
  const data = response as {
    data: {
      users: { id: string; username: string; email: string; is_controller: boolean }[];
    };
  };

  return data.data;
};

export const CampaignService = {
  getCampaigns,
  updateCampaignStatus,
  createCampaign,
  AddUsersInCampaign,
  RemoveUsersFromCampaign,
  getCampaignUsers,
};
